// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"228106bd","456":"e3dae239","656":"7cd93f1c","756":"8766cbd9","787":"49805157","968":"696be701"}[chunkId] + ".chunk.js";
};